import { faArrowRight, faEuroSign } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";

import "../../styles/service-card.css";
import InViewPort from "../utils/inveiwport";

export const ServiceCard = ({ cardData }) => {
    const { title, text, icon, boxcolor, price } = cardData;
    
    const navigateTo = useNavigate();

    const navigate = () => {
        navigateTo('/cleanerrequest',{
            state: title
        })
    }

    return (
        <InViewPort>
            <div className="card-container">
                <div className="flx-rw bt-jt">
                    <div
                        className="card-icon-box flx-rw c-al c-jt"
                        style={{ backgroundColor: boxcolor }}
                    >
                        <FontAwesomeIcon icon={icon} />

                    </div>
                    <div className="price-tag">
                        <div className="price-quote">
                            <FontAwesomeIcon icon={faEuroSign} />
                            {price}
                        </div>
                        <div className="unit-tag">pro Stunde</div>
                        <div className="unit-tag">pro Reiniger</div>
                    </div>
                </div>
                <div className="card-title">{title}</div>
                <div className="card-text">{text}</div>
                <div className="card-action">
                    <button 
                        className="action-button"
                        onClick={navigate}
                    >
                        <span className="see-more">Reinigungskraft anfordern – in wenigen Minuten</span>
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            </div>
        </InViewPort>
    )
}